import { Grid } from '@mui/material';
import GlConsolidationTabs from './GlConsolidationTabs';
import InvoiceApprovalTabs from './InvoiceApprovalTabs';
import LineItemSettings from './LineItemSettings';
import { useScopeCheck } from '../../../../reusable-components/scopes';

export default function InvoicingSettings() {
  const isSuperAdmin = useScopeCheck(['Super-Admin']);
  const isManualFacilityApproverEditor = useScopeCheck(['FacilityApprovers-Edit'], false, true);
  const isElectronicFacilityApproverEditor = useScopeCheck(['ElectronicFacilityApprovers-Edit'], false, true);

  const childHeightSx = { height: '100%', display: 'flex', flexDirection: 'column' };


  return (
    <Grid sx={{ mt: 4, ml: 1 }} container spacing={2} alignItems="stretch" >
      {isSuperAdmin && (<Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column' }}>
        <GlConsolidationTabs gridSx={gridSx} childHeightSx={childHeightSx} />
      </Grid>)}
      <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column' }}>
        <LineItemSettings gridSx={gridSx} heightSx={childHeightSx} />
      </Grid>
      {(isManualFacilityApproverEditor || isElectronicFacilityApproverEditor) &&
        <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column' }}>
          <InvoiceApprovalTabs
            isManualFacilityApproverEditor={isManualFacilityApproverEditor}
            isElectronicFacilityApproverEditor={isElectronicFacilityApproverEditor}
            gridSx={gridSx}
            heightSx={childHeightSx} />
        </Grid>}
    </Grid>
  );
}

const gridSx = {
  borderColor: '#fff',
  '& .MuiDataGrid-cell': {
    '&:focus-within': { outline: `none`, border: `none` },
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#fff',
    color: '#208ee0 !important',
  },
  '& .MuiDataGrid-columnHeader': {
    color: '#208ee0 !important',
    fontWeight: 'bold',
  },
  '& .MuiDataGrid-main': {
    borderRadius: 0,
    boxShadow: 0,
    backgroundColor: '#fff',
  },

  '& .MuiIconButton-root': {
    color: '#208ee0 !important',
  },
  '&   .MuiDataGrid-columnHeaders .MuiButtonBase-root .MuiSvgIcon-root': {
    height: '17px',
    width: '17px',
  },
  '& .MuiDataGrid-sortIcon': {
    color: '#208ee0 !important',
  },
};
